module.exports = __webpack_public_path__ + "img/Valbeveiliging_verplicht.de522598.jpg";